import React from "react";

import { Zoom, Fade } from "react-reveal";

import { Typography } from "@mui/material";

import Greet from "../../../assets/illustrations/greet.svg";

import bio from "../../../assets/data/info.json";

import "./intro.scss";

const Intro = () => {
    return (
        <div className="introContainer">
            <div className="introTitle fullHeight flexContainer fullSpace flexCol p-2">
                <div className="mt-2">
                    <Zoom>
                        <Typography variant="h4">
                            Hii, I am Aniruddha
                        </Typography>
                        <Typography variant="h6">
                            Currently, Software Engineer @{" "}
                            <a href={bio.aboutMe.company.url}>
                                {bio.aboutMe.company.title}
                            </a>
                        </Typography>
                    </Zoom>
                </div>
                <div className="introText flexGrow of-auto mt-1 mb-1 p-2">
                    <Fade bottom>
                        <Typography variant="body1">
                            {bio.aboutMe.intro.message}
                        </Typography>
                        <br />
                        <Typography variant="body1">
                            {bio.aboutMe.intro.current}
                        </Typography>
                    </Fade>
                </div>
            </div>
            <div className="polygon fullSpace">
                <div className="greetContainer flexContainer fullHeight">
                    <div className="greet">
                        <img src={Greet} alt="Introduction Illustration" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Intro;
